import React from 'react';
import { getKey } from '../../../../libs/utils/storageManager';
import { ReactComponent as Verified } from '../../../../assets/svg/verify-filled-icon.svg';
import { ReactComponent as NotVerified } from '../../../../assets/svg/red-x-line-icon.svg';

/**
 * Returns a verification status icon based on the validation state of a menu link.
 *
 * Logic:
 * - If the provided key corresponds to a 'valid' status in storage, it returns a green Verified icon.
 * - If the user has advanced past the current menu link (`activeMainMenu > link.order`)
 *   but the status is not 'valid', it returns a red Not Verified icon.
 * - If the current step hasn't been reached or no decision can be made, it returns null (renders nothing).
 *
 * @param link - The menu link object (must include an `order` property representing its position).
 * @param key - The unique key used to fetch validation status from storage.
 * @param activeMainMenu - The user's current active step in the menu flow.
 * @returns A JSX element (<Verified />, <NotVerified />) or null.
 */
export const checkMenuValid = (
    link: { order: number },
    key: string,
    activeMainMenu: number
  ): React.ReactNode => {
    const status = getKey(key);
  
    if (status === 'valid') {
      return <Verified />;
    }
  
    if (activeMainMenu > link.order) {
      return <NotVerified />;
    }
  
    return null;
  };